import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import { IconVideoPlay, RightSvg } from "@/assets/icons";
import { useCommonStore } from "@/stores";
import clsx from "clsx";
import { Template } from "@/components";
import { TTemplate } from "@/types";
import { AllPresetPanelMobileModalFn } from "../all-preset-panel/mobileModal";
import { FeatureType } from "@/stores/useCommonStore";
import {
  SINGLE_TEMP_WIDTH,
  MULTI_TEMP_WIDTH,
  SINGLE_TEMP_HEIGHT,
  MULTI_TEMP_HEIGHT,
} from "@/constants";
import { useEffect } from "react";

interface RecommendTempMobileProps {
  title: string;
  showMore?: boolean;
}
const RecommendTempMobile = (props: RecommendTempMobileProps) => {
  const { title, showMore = true } = props;
  const { t } = useTranslation();

  const recommendTempList = useCommonStore(
    (state) => state.getters.recommendTempList
  );
  const featureType = useCommonStore((state) => state.featureType);
  const isSingle = featureType === FeatureType.Single;
  const chooseTemp = useCommonStore((state) => state.chooseTemp);
  const chooseVideoTemp = useCommonStore((state) => state.chooseVideoTemp);
  // const setAllPresetVisible = useCommonStore(
  //   (state) => state.setAllPresetVisible
  // );

  useEffect(() => {
    useCommonStore.getState().fetchPresetGroupListByFeatureType();
  }, [featureType]);

  const handleClickTemp = (temp: TTemplate) => {
    // 视频单独处理
    if(featureType === FeatureType.Video) {
      chooseVideoTemp(temp);
    } else {
      chooseTemp(temp);
    }
  };

  const handleSeeAll = () => {
    const instance = AllPresetPanelMobileModalFn({
      onSelect: () => {
        instance.destroy();
      },
    });
  };
  const newRecommendTempList = recommendTempList.slice(0, 4);

  return (
    <div className={styles["root"]}>
      <div className={styles["header"]}>
        <span className={clsx(styles["title"], "single_row_ellipsis")}>
          {title}
        </span>
        {showMore && (
          <button className={styles["more_button"]} onClick={handleSeeAll}>
            <span>{t("right_recomment_see_all")}</span>
            <RightSvg></RightSvg>
          </button>
        )}
      </div>

      <div className={clsx(styles["temp_list"], "hide_scrollbar")}>
        {newRecommendTempList.map((item) => (
          <div key={item.id} className={styles["temp_wrap"]}>
            <Template
              {...item}
              {...item}
              leftBottomIcon={featureType === FeatureType.Video ? <IconVideoPlay /> : ""}
              initWidth={isSingle ? SINGLE_TEMP_WIDTH : MULTI_TEMP_WIDTH}
              initHeight={isSingle ? SINGLE_TEMP_HEIGHT : MULTI_TEMP_HEIGHT}
              onClick={() => handleClickTemp(item)}
            ></Template>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendTempMobile;
